import { i18n } from '@ecom-alliance/libs';
import { CommissionRateGroup } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
export var CREATOR_LEVEL_MAX_COUNT = 9;
export var FilterKey = /*#__PURE__*/function (FilterKey) {
  FilterKey["Categories"] = "categories";
  FilterKey["FollowerSize"] = "followerSize";
  FilterKey["ContentType"] = "contentType";
  FilterKey["CreatorAgency"] = "creatorAgency";
  FilterKey["CreatorLevel"] = "creatorLevel";
  FilterKey["IsFastGrowing"] = "isFastGrowing";
  FilterKey["FollowerAge"] = "followerAge";
  FilterKey["FollowerGender"] = "followerGender";
  FilterKey["Gmv"] = "gmv";
  FilterKey["UnitsSold"] = "unitsSold";
  FilterKey["AvgVideoViews"] = "avgVideoViews";
  FilterKey["AvgLiveViews"] = "avgLiveViews";
  FilterKey["EngagementRate"] = "engagementRate";
  FilterKey["AvgCommissionRate"] = "avgCommissionRate";
  FilterKey["PartneredBrand"] = "partneredBrand";
  FilterKey["IsInvitedBefore"] = "isInvitedBefore";
  FilterKey["SampleFulfillmentRate"] = "SampleFulfillmentRate";
  return FilterKey;
}({});
export var FilterTypeEnum = /*#__PURE__*/function (FilterTypeEnum) {
  FilterTypeEnum["Cascader"] = "cascader";
  FilterTypeEnum["Checkbox"] = "checkbox";
  FilterTypeEnum["Select"] = "select";
  FilterTypeEnum["MultiSelect"] = "multiSelect";
  FilterTypeEnum["MultiSelectSearch"] = "multiSelectSearch";
  FilterTypeEnum["SelectSlider"] = "selectSlider";
  FilterTypeEnum["InputSliderCheckbox"] = "inputSliderCheckbox";
  FilterTypeEnum["RangeInputSlider"] = "rangeInputSlider";
  return FilterTypeEnum;
}({});
export var getFilterFormInitValue = function getFilterFormInitValue(params) {
  var _params$followerSizeM, _ref;
  return _ref = {}, _ref[FilterKey.Categories] = [], _ref[FilterKey.IsFastGrowing] = false, _ref[FilterKey.FollowerSize] = {
    value: {
      min: 0,
      max: (_params$followerSizeM = params === null || params === void 0 ? void 0 : params.followerSizeMaxNum) !== null && _params$followerSizeM !== void 0 ? _params$followerSizeM : 1e7,
      isPositiveInf: true
    }
  }, _ref[FilterKey.ContentType] = {
    value: '',
    label: i18n.t('creator_marketplace_detail_trend_tab1', 'All')
  }, _ref[FilterKey.CreatorAgency] = {
    value: '',
    label: i18n.t('creator_marketplace_detail_trend_tab1', 'All')
  }, _ref[FilterKey.CreatorLevel] = params === null || params === void 0 ? void 0 : params.creatorLevelOptions, _ref[FilterKey.FollowerGender] = {
    selectVal: {
      value: ''
    },
    inputVal: 50
  }, _ref[FilterKey.AvgVideoViews] = {
    lowerBoundValue: 0,
    checkboxValue: false
  }, _ref[FilterKey.AvgLiveViews] = {
    lowerBoundValue: 0,
    checkboxValue: false
  }, _ref[FilterKey.EngagementRate] = {
    lowerBoundValue: 0,
    checkboxValue: false
  }, _ref[FilterKey.AvgCommissionRate] = {
    value: CommissionRateGroup.COMMISSION_GROUP_NO_THRESHOLD,
    label: i18n.t('affiliate_creator_connect_filter_nothreshold', 'No threshold')
  }, _ref[FilterKey.IsInvitedBefore] = false, _ref[FilterKey.SampleFulfillmentRate] = {
    value: '',
    label: i18n.t('seller_sample_fulfillment_rate_filter_1', 'All')
  }, _ref;
};
export var FILTER_CONTAINER_ID = 'filter-container';